import {ReviewDataChildType} from '../../../../../service/reviews/reviews-type';

export function getReplyCount(replyChildren: Array<ReviewDataChildType>): number {
    return replyChildren.reduce((result: number, replyChild: ReviewDataChildType) => {
        return result + 1 + getReplyCount(replyChild.children);
    }, 0);
}
